import { useEffect, useState } from 'react';
import { GridOverlay, GridOverlayProps } from '@mui/x-data-grid-pro';
import { useIsMounted } from '@bymason/util-hooks';
import { Text } from '../Text';

export function DataGridNoResultsOverlay({
  text = 'No results found at this time',
}: DataGridNoResultsOverlayProps) {
  const isMounted = useIsMounted();
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted()) {
        setShowText(true);
      }
    }, 250);
  }, [isMounted]);

  return <GridOverlay>{showText && <Text>{text}</Text>}</GridOverlay>;
}

interface DataGridNoResultsOverlayProps extends GridOverlayProps {
  text?: string;
}
